export const BOAT = "boat"
export const CREW = "crew"
export const SALE = "sale"
export const RENTAL = "rental"
export const FLEET = "fleet"
